import { Component, inject, input, signal } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { KENDO_BUTTONS } from '@progress/kendo-angular-buttons';
import { KENDO_DIALOGS } from '@progress/kendo-angular-dialog';
import { InputType, KENDO_FORMFIELD } from '@progress/kendo-angular-inputs';
import { KENDO_LABEL } from '@progress/kendo-angular-label';
import { FormSchemaDataDto } from '@unity/clients';
import { ControlWrapperComponent } from '@unity/forms/composed/control-wrapper/control-wrapper.component';
import { IconService } from '@unity/services/icon.service';
import { DialogSurveyCreatorSharedComponent } from '@unity/shared/dialog-survey-creator-shared/dialog-survey-creator-shared.component';

@Component({
  selector: 'unity-survey-creator-control',
  standalone: true,
  imports: [
    KENDO_FORMFIELD,
    KENDO_BUTTONS,
    KENDO_LABEL,
    KENDO_DIALOGS,
    ReactiveFormsModule,
    ControlWrapperComponent,
    DialogSurveyCreatorSharedComponent,
  ],
  templateUrl: './survey-creator-control.component.html',
  styleUrl: './survey-creator-control.component.scss',
})
export class SurveyCreatorControlComponent {
  private readonly iconService = inject(IconService);

  public readonly $control = input.required<FormControl<FormSchemaDataDto>>({ alias: 'control' });
  public readonly $displayName = input.required<string>({ alias: 'displayName' });
  public readonly $description = input.required<string>({ alias: 'description' });

  public readonly $showHint = input(true, { alias: 'showHint' });
  public readonly $type = input<InputType>('text', { alias: 'type' });
  public readonly $clearButton = input<boolean>(false, { alias: 'clearButton' });

  protected readonly $isOpen = signal(false);
  protected trackChangesEnableIcon = this.iconService.trackChangesEnableIcon;

  protected onClick() {
    this.$isOpen.set(true);
  }

  protected onClose() {
    this.$isOpen.set(false);
  }
}
